import authResourceApi from './auth';
import ranksResourceApi from './ranks';
import vesselResourceApi from './vessels';
import userResourceApi from './users';
import portResourceApi from './ports';
import ownerResourceApi from './owners';
import managerResourceApi from './managers';
import crewUserResourceApi from './crewUsers';
import timeplansResourceApi from './timeplans';
import selectedVesselResourceApi from './assignedVessels';
import selectedOwnerResourceApi from './assignedOwners';
import vacancyContacts from './vacancyContacts';
import crewingAgents from './crewingAgents';
import crewingStatuses from './crewingStatuses';
import engineTypes from './engineTypes';
import engineManufacturers from './engineManufacturers';
import comments from './comments';
import manningScales from './manningScales';
import crewList from './crewList';
import crewChange from './crewChange';
import daxPortCalls from './daxPortCalls';
import userExperiences from './userExperiences';
import vesselExperiences from './vesselExperiences';
import vacancies from './vacancies';
import vesselTypes from './vesselTypes';
import vendorTypes from './vendorTypes';
import vendors from './vendors';
import certificateTypes from './certificateTypes';
import crewingRelationTypes from './crewingRelationTypes';
import userAttachments from './userAttachments';
import userCertificates from './userCertificates';
import userRelatives from './userRelatives';
import countries from './countries';
import mainEngines from './mainEngines';
import applicantContracts from './applicantContracts';
import applicantDocuments from './userDocuments';
import applicantInterviews from './userInterviews';
import englishTestTypes from './englishTestTypes';
import userEnglishTests from './userEnglishTests';
import userRecommendations from './userRecommendations';
import selectOptionsApi from './selectOptions';
import equasisVesselSearchApi from './equasisVesselSearch';
import crewingApplicants from './crewingApplicants';
import crewisorPositionCommentTypes from './crewisorPositionCommentTypes';
import commentEvents from './commentEvents';
import roleLevels from './roleLevels';
import favorites from './favorites';
import experienceVerifications from './userExperienceVerifications';
import appFormLinks from './appFormLinks';
import crewWages from './crewWages';
import wageComponents from './wageComponents';
import performances from './performances';
import taskManager from './taskManager';
import ownerDocumentMatrix from './ownerDocumentMatrix';
import ownerEquipmentMatrix from './ownerEquipmentMatrix';
import vacancyApplies from './vacancyApplies';
import notificationManager from './notificationManager';
import surveyCreator from './surveyCreator';
import permissions from './permissions';
import externalObjectsHistory from './externalObjectsHistory';
import duplicateManagement from './duplicateManagement';
import recruitingMetrics from './recruitingMetrics';
import vacancySettings from './vacancySettings';
import documentImports from './documentImports';

export default {
  test: { read: () => [] }, // for testing
  auth: authResourceApi,
  vessels: vesselResourceApi,
  assignedVessels: selectedVesselResourceApi,
  assignedOwners: selectedOwnerResourceApi,
  vacancyContacts,
  ranks: ranksResourceApi,
  selectOptions: selectOptionsApi,
  timeplans: timeplansResourceApi,
  users: userResourceApi,
  ports: portResourceApi,
  owner: ownerResourceApi,
  manager: managerResourceApi,
  crewUser: crewUserResourceApi,
  crewingAgents,
  crewingStatuses,
  engineTypes,
  engineManufacturers,
  comments,
  manningScales,
  crewList,
  crewChange,
  daxPortCalls,
  userExperiences,
  vesselExperiences,
  vacancies,
  vesselTypes,
  vendorTypes,
  vendors,
  certificateTypes,
  crewingRelationTypes,
  countries,
  userAttachments,
  userCertificates,
  userRelatives,
  mainEngines,
  applicantContracts,
  applicantDocuments,
  applicantInterviews,
  englishTestTypes,
  userEnglishTests,
  userRecommendations,
  equasisVesselSearch: equasisVesselSearchApi,
  crewingApplicants,
  crewisorPositionCommentTypes,
  commentEvents,
  roleLevels,
  favorites,
  experienceVerifications,
  externalObjectsHistory,
  appFormLinks,
  crewWages,
  wageComponents,
  performances,
  taskManager,
  ownerDocumentMatrix,
  ownerEquipmentMatrix,
  vacancyApplies,
  notificationManager,
  surveyCreator,
  permissions,
  duplicateManagement,
  recruitingMetrics,
  vacancySettings,
  documentImports,
};
